import React from 'react';
import { ReporteProvider } from '../../context/ReporteContext';
import FormularioReporteMovil from '../../components/reportes/FormularioReporteMovil';

/**
 * Vista móvil para crear un nuevo reporte
 * Optimizada para pantallas pequeñas con navegación paso a paso
 */
const CrearReporteMovilView: React.FC = () => {
  return (
    <ReporteProvider>
      <FormularioReporteMovil />
    </ReporteProvider>
  );
};

export default CrearReporteMovilView;
